import type { QueueCard } from "@/hooks/use-oppdag-queue";
import type { FollowUpAction } from "@/lib/follow-up-calc";
import FollowUpCard from "./FollowUpCard";
import SignalCard from "./SignalCard";
import type { ComponentProps } from "react";

interface QueueCardStackProps {
  card: QueueCard;
  /** Antall kort bak dette; styrer «stabelen» uten å avsløre innholdet. */
  behind: number;
  onAction: (action: FollowUpAction) => void;
  /** Plass og antall for oppfølgingskortet. */
  followUpPosition?: { position: number; total: number };
  /** Lar køen starte Avvis-sveipet på oppfølgingskortet fra tastaturet. */
  followUpDismissRef?: ComponentProps<typeof FollowUpCard>["dismissRef"];
  /** Handlinger for signalkort; påkrevd når kortet er et signal. */
  signalActions?: Omit<ComponentProps<typeof SignalCard>, "signal">;
}

/** Viser ett kort om gangen, med to tomme kortkanter bak når det er flere. */
export default function QueueCardStack({ card, behind, onAction, followUpPosition, followUpDismissRef, signalActions }: QueueCardStackProps) {
  return (
    <div className="relative pb-3">
      {behind >= 2 && <div aria-hidden className="absolute inset-x-4 bottom-0 h-3 border-[1.5px] border-t-0 border-foreground/50 bg-card" />}
      {behind >= 1 && <div aria-hidden className="absolute inset-x-2 bottom-1.5 h-3 border-[1.5px] border-t-0 border-foreground/70 bg-card" />}
      <div className="relative">
        {card.kind === "follow_up" && <FollowUpCard key={card.followUp.id} followUp={card.followUp} onAction={onAction} dismissRef={followUpDismissRef} {...followUpPosition} />}
        {/* key: nytt kort for hvert signal, så sveipet fra forrige kort ikke henger igjen. */}
        {card.kind === "signal" && signalActions && <SignalCard key={card.signal.id} signal={card.signal} {...signalActions} />}
      </div>
    </div>
  );
}
